export default [
  {
    path: 'packageManager',
    name: 'packageManager',
    component: () => import('./packageManager'),
    meta: {
      noLimit: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/views/package/index.route.js